/**
 * @ComponentFor Avensia.Shop.Features.Category.Commerce.Components.CategoryHeader
 */
import classnames from "classnames";
import MyMenigoIcon from "../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon";
import React, { useEffect, useRef } from "react";
import { EpiProperty } from "@avensia/nitro5-scope-episerver";
import * as styles from "../base.scss";
import connect from "Shared/connect";
import getMenuIcon from "./action-creators";
import NewsBanner from "SiteLayout/Header/FadeHeader/Components/QuickSearch/NewsBanner";
import { getQueryStringParameterByName } from "./../../../MyMenigo/Blocks/DeliveryBlock/Components/action-creators";
import { conceptFilterParameterName } from "Shared/Facet/ConceptFacet";
const CategoryPageHeader = (props) => {
    const ref = useRef(null);
    const subCategories = !!props.categories &&
        !!(props.categories.length > 0) &&
        [...props.categories].sort((a, b) => a.displayName.localeCompare(b.displayName, "sv-SE"));
    const newsBannerBlocks = props.newsBannerArea;
    const newsBannerContent = !!newsBannerBlocks &&
        !!newsBannerBlocks.items &&
        !!newsBannerBlocks.items[0] &&
        newsBannerBlocks.items[0];
    const getConceptBreadCrumbItem = (onlyItem) => {
        const activeConcept = !!props.activeConcept &&
            getQueryStringParameterByName(conceptFilterParameterName);
        if (!activeConcept)
            return React.createElement(React.Fragment, null);
        if (onlyItem)
            return (React.createElement("li", { key: "conceptBreadcrumb", className: styles.backToConcept },
                React.createElement(MyMenigoIcon, { name: "arrow" }),
                React.createElement("a", { className: styles.link, href: props.activeConcept.conceptUrl }, props.activeConcept.displayName)));
        else
            return (React.createElement("ul", { className: classnames(styles.categoryList, styles.breadcrumbsList) }, getConceptBreadCrumbItem(true)));
    };
    useEffect(() => {
        const el = ref.current;
        el.scrollLeft = 0;
    }, [props]);
    return (React.createElement("div", { className: classnames(styles.categoryHeader, {
            [styles.withBanner]: !!newsBannerContent,
        }) },
        !!newsBannerContent && (React.createElement("div", { className: styles.newsBanner },
            React.createElement(NewsBanner, Object.assign({}, newsBannerContent)))),
        React.createElement("div", { className: styles.inner },
            !!props.breadcrumbs && props.breadcrumbs.length > 1 ? (React.createElement("div", { className: styles.categoryBreadcrumbsWrap },
                React.createElement("ul", { className: classnames(styles.categoryList, styles.breadcrumbsList) },
                    getConceptBreadCrumbItem(true),
                    props.breadcrumbs
                        .slice(1, props.breadcrumbs.length)
                        .map(({ url, text }, i, array) => {
                        const isCurrentBreadcrumb = i === array.length - 1;
                        return (React.createElement("li", { key: text },
                            isCurrentBreadcrumb ? (React.createElement("span", null, text)) : (React.createElement("a", { className: styles.link, href: url + window.location.search }, text)),
                            !isCurrentBreadcrumb && React.createElement(MyMenigoIcon, { name: "caret" })));
                    })))) : (getConceptBreadCrumbItem(false)),
            React.createElement(EpiProperty, { className: styles.categoryHeaderName, component: "h1", for: props.headerProperty }),
            React.createElement("ul", { ref: ref, className: styles.categoryList }, !!subCategories &&
                subCategories
                    .filter((x) => x.productCount > 0)
                    .map((category, i) => (React.createElement("li", { key: category.code },
                    React.createElement("a", { className: styles.button, "data-ticket": category.ticket, href: category.url + window.location.search },
                        !!getMenuIcon(category, props.categoryIcons) && (React.createElement(MyMenigoIcon, { name: getMenuIcon(category, props.categoryIcons) })),
                        React.createElement("span", null, category.displayName)))))))));
};
export default connect((state) => ({
    categoryIcons: state.appShellData.categoryIcons,
}))(CategoryPageHeader);
